import React from "react";
import { MapPin } from "lucide-react";

const PROJECTS = [
  { location: "Gurugram, Cyber City", category: "Tech Office Clearance", scope: "500+ laptops, 40 server racks and complete modular furniture buyback." },
  { location: "Noida, Sector 62", category: "Data Center Decommissioning", scope: "UPS systems, core routers, certified data wiping and site handover." },
  { location: "Bangalore, Electronic City", category: "Office Migration", scope: "350 workstations, VRF AC dismantling and GST-compliant liquidation." },
  { location: "Delhi NCR, Okhla", category: "IT Asset Buyback", scope: "Bulk lot purchase of 800+ desktops, monitors and power backups." },
];

export const CorpProjects = () => (
  <section id="projects" data-testid="corporate-projects-section" className="home-section home-section--corporate scroll-mt-24 bg-white">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p className="text-[12px] font-bold uppercase tracking-[0.16em]" style={{ color: "#E8501A" }}>Track Record</p>
      <h2 data-testid="corporate-projects-heading" className="mt-2 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl" style={{ color: "var(--green-950)" }}>
        Recent Corporate Asset Projects
      </h2>
      <div data-testid="corporate-projects-grid" className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {PROJECTS.map((p, i) => (
          <div key={i} data-testid={`project-card-${i}`}
               className="flex flex-col rounded-xl border bg-white p-6 transition-all duration-300 hover:border-[color:var(--green-800)] hover:shadow-md"
               style={{ borderColor: "#E2E8F0" }}>
            <span data-testid={`project-location-${i}`} className="inline-flex w-fit items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide"
                  style={{ background: "#E8F4ED", color: "var(--green-800)" }}>
              <MapPin size={11} /> {p.location}
            </span>
            <h3 data-testid={`project-heading-${i}`} className="mt-4 font-heading text-[16px] font-bold leading-snug" style={{ color: "var(--green-950)" }}>
              {p.category}
            </h3>
            <p data-testid={`project-scope-${i}`} className="mt-2 text-[13.5px] leading-relaxed text-slate-500">{p.scope}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
